// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/configuration/general',
    name: 'configuration-general',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/configuration/identificador/General.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'configuration_general',
    },
  },
]

export default formTable
